import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  handleSubmit() {
    var hiddenLongDescription = document.querySelector('input[class=partner_long_description]');
    var quillEditor = document.querySelector('div[class=ql-editor]');
    if(quillEditor) {
      hiddenLongDescription.value = quillEditor.innerHTML;
    }
  }
}
